import { message } from 'antd';
import { authHeader } from '../../../../helpers/auth-header';
import { client } from '../../../../actions';
import uri from '../../constants/uri';

const deleteFile = async (fileId) => {
  try {
    const res = await client.delete(`${uri}/delete_file`, {
      headers: authHeader(),
      params: {
        fileId,
      },
    });
    if (res?.data?.result === 'OK') {
      message.success('Файл удалён');
      return;
    }

    throw new Error('Не получилось удалить файл');
  } catch (error) {
    message.error('Не получилось удалить файл');
    console.error(error);
  }
};

export default deleteFile;
